import classNames from "classnames";
import { Fragment } from "react";
import { useFormContext } from "react-hook-form";
import type { ZypeSubscriptionPlan } from "@inferno/renderer-shared-core";
import { Button, ButtonKind } from "../../../../../core/ui";
import Heading from "../../../../../core/ui/Heading.component";
import { FORM_ERRORS, RadioInput, RadioOption, SelectInput, SelectOption } from "../../forms";
import { CoastSubscriptionIntro } from "./CoastSubscriptionIntro.components";

interface CoastPickYourPlanProps {
  setIsGift: (isGift: boolean) => void;
  plans: ZypeSubscriptionPlan[];
  goForward: () => void;
  onCancel: () => void;
  stepNumber: number;
  stepCount: number;
  hidden: boolean;
  isGift: boolean;
  showCountrySelect: boolean;
}

export interface CoastPickYourPlanInputs {
  country: string;
  planId: string;
}

export const CoastPickYourPlan = ({
  setIsGift,
  goForward,
  plans,
  isGift,
  hidden,
  stepNumber,
  stepCount,
  onCancel,
  showCountrySelect = false,
}: CoastPickYourPlanProps) => {
  const { register, handleSubmit, errors } = useFormContext<CoastPickYourPlanInputs>();

  return (
    <section className={classNames("component-pick-your-plan", "sign-up-step", { hidden })}>
      <CoastSubscriptionIntro isGift={isGift} />

      <p className="step-indicator">
        Step {stepNumber} of {stepCount}
      </p>

      <Heading level={2} className="section-title">
        Pick Your {isGift ? "Gift" : ""} Plan.
      </Heading>

      <p className="section-info">
        {isGift ? (
          <Button click={() => setIsGift(false)} className="button-info-inline" kind={ButtonKind.CUSTOMIZED}>
            Add a subscription to your account
          </Button>
        ) : (
          <Fragment>
            You can change or cancel your plan anytime. &nbsp;
            <Button className="button-info-inline" click={() => setIsGift(true)} kind={ButtonKind.CUSTOMIZED}>
              Give as a gift
            </Button>
          </Fragment>
        )}
      </p>

      <form onSubmit={handleSubmit(goForward)}>
        {showCountrySelect ? (
          <SelectInput
            register={register}
            rules={{ required: FORM_ERRORS.required }}
            error={errors.country}
            placeholder={{ label: "Select your country...", value: "" }}
            label="Select Your Location"
            name="country"
          >
            <SelectOption label="United States" value="US" />
            <SelectOption label="Canada" value="CA" />
          </SelectInput>
        ) : (
          <input value="US" name="country" readOnly={true} hidden={true} type="text" />
        )}
        <RadioInput label="Select Your Plan" error={errors.planId} direction="vertical" name="planId">
          {plans
            .filter(({ third_party_id }) => (third_party_id === "gift") === isGift)
            .map(p => (
              <RadioOption
                rules={{ required: FORM_ERRORS.required }}
                error={errors.planId}
                name="planId"
                register={register}
                label={p.description}
                value={p._id}
                key={p._id}
              />
            ))}
        </RadioInput>

        <div className="button-prev-next">
          <Button
            disabled={!!errors.country || !!errors.planId}
            kind={ButtonKind.CUSTOMIZED}
            className="button-continue"
            type="submit"
          >
            Continue
          </Button>
          <Button kind={ButtonKind.CUSTOMIZED} className="button-previous" disabled={true}>
            Previous
          </Button>
        </div>
      </form>
      <Button className="button-cancel" click={onCancel} kind={ButtonKind.CUSTOMIZED}>
        Cancel
      </Button>
    </section>
  );
};
